module.exports = __webpack_public_path__ + "img/car3ip_02.e704dd54.png";